import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Check if the route has data and preload is set to true
    if (route.data && route.data['preload'] === true) {
      // Preload the module
      return load();
    } else {
      // Don't preload
      return of(null);
    }
  }
}
